module.exports = __webpack_public_path__ + "img/g3.b763996c.png";